package com.checkin.host.ui.legal

import androidx.compose.runtime.Composable
import com.checkin.host.ui.components.BrandLogo
import com.checkin.host.theme.AppColors
import com.checkin.shared.legal.LegalDocument
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun LegalPageScreen(
    document: LegalDocument,
    onBack: () -> Unit,
) {
    Div({
        style {
            property("min-height", "100dvh")
            backgroundColor(AppColors.bg)
            color(AppColors.text)
            padding(24.px, 16.px, 48.px, 16.px)
        }
    }) {
        Div({
            style {
                property("max-width", "720px")
                margin(0.px)
                property("margin-left", "auto")
                property("margin-right", "auto")
            }
        }) {
            Div({ style { display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); marginBottom(20.px) } }) {
                BrandLogo(size = 40.px)
            }

            Button({
                style {
                    border(0.px)
                    backgroundColor(Color.transparent)
                    color(AppColors.primary)
                    cursor("pointer")
                    fontSize(14.px)
                    padding(0.px)
                    marginBottom(16.px)
                }
                onClick { onBack() }
            }) {
                Text("← Retour")
            }

            H1({
                style {
                    fontSize(26.px)
                    margin(0.px, 0.px, 16.px, 0.px)
                }
            }) {
                Text(document.title)
            }

            Div({
                style {
                    backgroundColor(AppColors.surface)
                    borderRadius(12.px)
                    padding(24.px)
                    border(1.px, LineStyle.Solid, AppColors.border)
                }
            }) {
                LegalDocumentView(document)
            }
        }
    }
}
